module.exports = __webpack_public_path__ + "img/idle.4e644e37.png";